import { all, put, takeEvery, fork } from "redux-saga/effects";
import { apiURL } from "../actions/helpers";
import axios from "axios";

// Action Types
export const CRYPTO_SHEET_LOAD = "CS/LOAD";
export const CRYPTO_SHEET_LOAD_SUCCESS = "CS/LOAD/SUCCESS";
export const CRYPTO_SHEET_LOAD_FAILURE = "CS/LOAD/FAILURE";
export const CRYPTO_SHEET_SOCKET_UPDATE = "CS/SOCKET_UPDATE";

// Action Creators
export const cryptoSheetLoad = () => ({
  type: CRYPTO_SHEET_LOAD,
});

export const cryptoSheetLoadSuccess = (data, loading) => ({
  type: CRYPTO_SHEET_LOAD_SUCCESS,
  data,
  loading,
});

export const cryptoSheetLoadFailure = (error) => ({
  type: CRYPTO_SHEET_LOAD_FAILURE,
  error,
});

export const cryptoSheetSocketUpdate = (newRow) => ({
  type: CRYPTO_SHEET_SOCKET_UPDATE,
  newRow,
});

// Sagas
function* fetchCryptoSheet() {
  try {
    yield put(
      cryptoSheetLoadSuccess({
        rows: [],
        loading: true,
      }),
    );

    const { data } = yield axios.get(`${apiURL}/crypto-sheet`, {
      withCredentials: true,
    });

    yield put(
      cryptoSheetLoadSuccess({
        rows: data.rows || [],
        raw: data.raw || [],
        range: data.range || "",
        majorDimension: data.majorDimension || "",
        fetchedAt: data.fetchedAt || "",
        loading: false,
      }),
    );
  } catch (error) {
    console.log({ error }, "err in crypto sheet loader");
    yield put(cryptoSheetLoadFailure(error));
  }
}

function* listenCryptoSheetLoad() {
  yield takeEvery(CRYPTO_SHEET_LOAD, fetchCryptoSheet);
}

// Root Saga
export function* saga() {
  yield all([fork(listenCryptoSheetLoad)]);
}

const INIT_STATE = {
  rows: [],
  raw: [],
  range: "",
  majorDimension: "",
  fetchedAt: "",
  loading: true,
  error: null,
};

// Reducer
const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CRYPTO_SHEET_LOAD_SUCCESS:
      return {
        ...state,
        rows: action.data.rows,
        raw: action.data.raw,
        range: action.data.range,
        majorDimension: action.data.majorDimension,
        fetchedAt: action.data.fetchedAt,
        loading: action.data.loading,
        error: null,
      };
    case CRYPTO_SHEET_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case CRYPTO_SHEET_SOCKET_UPDATE:
      return {
        ...state,
        rows: [action.newRow, ...state.rows],
        fetchedAt: new Date().toISOString(),
      };
    default:
      return state;
  }
};

export default reducer;
